import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

export default class Storeinpendingservice {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getstoreinpendingList(
    index,
    size,
    sortColumn,
    sortOrder,
    search,
    selectedBranch,
    orderFromDate,
    orderToDate,
    showZeroDayDelay,
    showOneDayDelay
  ) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_STORE_IN_PENDING_LIST });
    let itemArray = [];
    await myApi.endpoints[this.endpoint.GET_STORE_IN_PENDING_LIST]
      .getAllPost({
        storeIDs: [null, undefined, ""].includes(selectedBranch)
          ? localStorage.getItem("branchID")
          : selectedBranch,
        orderFromDate: orderFromDate,
        orderToDate: orderToDate,
        showZeroDayDelay:showZeroDayDelay,
        showOneDayDelay:showOneDayDelay,
        pageIndex: index,
        pageSize: size,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        commonSearch: search,
      })
      .then(({ data }) => {
        itemArray = data;
      })
      .catch((err) => {
        itemArray = this.common.handleError(err);
      });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getstoreinpendingList(
          index,
          size,
          sortColumn,
          sortOrder,
          search
        );
      });
    }
    return Promise.resolve(itemArray);
  }
}
